import React, { useState } from 'react';

const POSTURE_POSITIONS = [
  { id: 'standing', label: 'Standing' },
  { id: 'sitting',  label: 'Sitting'  },
  { id: 'lying',    label: 'Lying'    },
];

const FRONTAL_FINDINGS = [
  'Normal alignment','Head tilt (R)','Head tilt (L)',
  'Shoulder elevation (R)','Shoulder elevation (L)',
  'Lateral trunk lean (R)','Lateral trunk lean (L)',
  'Pelvic obliquity (R↑)','Pelvic obliquity (L↑)',
  'Scoliosis – convex R','Scoliosis – convex L',
  'Knee valgus (R)','Knee valgus (L)','Knee varus (R)','Knee varus (L)',
  'Foot pronation','Foot supination',
];

const SAGITTAL_FINDINGS = [
  'Normal alignment','Forward head posture','Chin poke',
  'Thoracic kyphosis','Flat thoracic spine',
  'Hyperlordosis (lumbar)','Flat back (lumbar)',
  'Swayback posture','Hip flexion (R)','Hip flexion (L)',
  'Knee flexion contracture','Knee hyperextension',
  'Equinus (plantarflexion)','Posterior pelvic tilt','Anterior pelvic tilt',
];

const PostureAssessment = ({ value = {}, onChange }) => {
  const [open, setOpen] = useState(false);

  const toggle = (key, f) => {
    const curr = value[key] || [];
    onChange?.({ ...value, [key]: curr.includes(f) ? curr.filter(x => x !== f) : [...curr, f] });
  };

  const abnormalCount = POSTURE_POSITIONS.filter(p => {
    const fv = value[`${p.id}_frontal`] || [];
    const sv = value[`${p.id}_sagittal`] || [];
    const allNormal = [...fv, ...sv].every(f => f === 'Normal alignment');
    return (fv.length > 0 || sv.length > 0) && !allNormal;
  }).length;
  const assessedCount = POSTURE_POSITIONS.filter(p => (value[`${p.id}_frontal`]?.length || 0) + (value[`${p.id}_sagittal`]?.length || 0) > 0).length;

  return (
    <div style={{ marginBottom: '8px' }}>
      {!open ? (
        <button type="button" onClick={() => setOpen(true)} style={{
          width: '100%', padding: '15px', borderRadius: '14px',
          border: '1px solid #e2e8f0', backgroundColor: 'transparent', color: '#5b21b6',
          fontSize: '0.95rem', fontWeight: '700', cursor: 'pointer',
          display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', transition: 'all 0.2s'
        }}>
          + Postural Assessment
          {assessedCount > 0 && <span style={{ fontSize: '11px', padding: '2px 10px', borderRadius: '20px', background: '#5b21b6', color: '#fff', fontWeight: 800 }}>{assessedCount}/3 positions assessed</span>}
          {abnormalCount > 0 && <span style={{ fontSize: '11px', padding: '2px 10px', borderRadius: '20px', background: '#dc2626', color: '#fff', fontWeight: 800 }}>{abnormalCount} abnormal</span>}
        </button>
      ) : (
        <div style={{ padding: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
            <span style={{ fontWeight: '800', fontSize: '1rem', color: '#5b21b6' }}>🧍 Postural Assessment</span>
            <button type="button" onClick={() => setOpen(false)} style={{ background: 'none', border: 'none', color: '#cbd5e1', fontSize: '1.6rem', cursor: 'pointer', lineHeight: 1 }} onMouseEnter={e => e.target.style.color = '#ef4444'} onMouseLeave={e => e.target.style.color = '#cbd5e1'}>×</button>
          </div>

          <div style={{ display: 'flex', gap: '6px', marginBottom: '12px', padding: '8px 12px', borderRadius: '10px', background: '#ede9fe', fontSize: '11px', color: '#5b21b6', fontWeight: 600 }}>
            Select all findings per view. Multiple selections allowed per position.
          </div>

          <div style={{ overflowX: 'auto', borderRadius: '12px' }}>
          <div style={{ border: '0.5px solid #ddd6fe', background: '#fff', minWidth: '380px' }}>
            {/* Header */}
            <div style={{ display: 'grid', gridTemplateColumns: '110px 1fr 1fr', background: '#ede9fe', padding: '8px 14px', borderBottom: '0.5px solid #ddd6fe' }}>
              <div style={{ fontSize: '11px', fontWeight: 800, color: '#5b21b6' }}>Position</div>
              <div style={{ fontSize: '11px', fontWeight: 800, color: '#5b21b6', textAlign: 'center' }}>Frontal View</div>
              <div style={{ fontSize: '11px', fontWeight: 800, color: '#5b21b6', textAlign: 'center' }}>Sagittal View</div>
            </div>

            {POSTURE_POSITIONS.map((pos, idx) => {
              const fv = value[`${pos.id}_frontal`] || [];
              const sv = value[`${pos.id}_sagittal`] || [];
              const hasAbnormal = [...fv, ...sv].some(f => f !== 'Normal alignment');
              return (
                <div key={pos.id} style={{ display: 'grid', gridTemplateColumns: '110px 1fr 1fr', borderBottom: idx < POSTURE_POSITIONS.length - 1 ? '0.5px solid #f1f5f9' : 'none', background: hasAbnormal ? '#faf7ff' : '#fff' }}>
                  <div style={{ padding: '12px 14px', fontSize: '13px', fontWeight: 800, color: '#374151', borderRight: '0.5px solid #f1f5f9', display: 'flex', alignItems: 'flex-start' }}>{pos.label}</div>
                  {/* Frontal */}
                  <div style={{ padding: '10px 12px', borderRight: '0.5px solid #f1f5f9', display: 'flex', flexWrap: 'wrap', gap: '4px', alignContent: 'flex-start' }}>
                    {FRONTAL_FINDINGS.map(f => {
                      const active = fv.includes(f);
                      const isNormal = f === 'Normal alignment';
                      return (
                        <button key={f} type="button" onClick={() => toggle(`${pos.id}_frontal`, f)} style={{
                          fontSize: '10px', fontWeight: 600, padding: '3px 8px', borderRadius: '20px', cursor: 'pointer', transition: 'all 0.15s',
                          border: `1px solid ${active ? (isNormal ? '#6ee7b7' : '#c4b5fd') : '#e2e8f0'}`,
                          background: active ? (isNormal ? '#ecfdf5' : '#ede9fe') : 'transparent',
                          color: active ? (isNormal ? '#059669' : '#5b21b6') : '#64748b'
                        }}>{active ? '✓ ' : ''}{f}</button>
                      );
                    })}
                  </div>
                  {/* Sagittal */}
                  <div style={{ padding: '10px 12px', display: 'flex', flexWrap: 'wrap', gap: '4px', alignContent: 'flex-start' }}>
                    {SAGITTAL_FINDINGS.map(f => {
                      const active = sv.includes(f);
                      const isNormal = f === 'Normal alignment';
                      return (
                        <button key={f} type="button" onClick={() => toggle(`${pos.id}_sagittal`, f)} style={{
                          fontSize: '10px', fontWeight: 600, padding: '3px 8px', borderRadius: '20px', cursor: 'pointer', transition: 'all 0.15s',
                          border: `1px solid ${active ? (isNormal ? '#6ee7b7' : '#c4b5fd') : '#e2e8f0'}`,
                          background: active ? (isNormal ? '#ecfdf5' : '#ede9fe') : 'transparent',
                          color: active ? (isNormal ? '#059669' : '#5b21b6') : '#64748b'
                        }}>{active ? '✓ ' : ''}{f}</button>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>

          </div>

          {Object.keys(value).length > 0 && <button type="button" onClick={() => onChange({})} style={{ marginTop: '10px', fontSize: '12px', background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer', textDecoration: 'underline' }}>Clear all posture data</button>}
        </div>
      )}
    </div>
  );
};

export default PostureAssessment;
